import React, { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { getAccount } from '../../../Api'
import downloadPurple from '../../SearchResults/images/DownloadSVG.svg'
import useStore from '../BusinessStore/Store'
import arrowLeft from '../images/arrowLeft.svg'
import arrowRight from '../images/arrowRight.svg'
import ExampleSearches from './ExampleResults/ExampleSearches'
import Results from './ListOfResults/Results'
import DownloadModal from '../../DownloadDr6/DownloadModal' // Import the DownloadModal for business data
import styles from './styles.module.css'

function SearchResults () {
  const {
    data: AccountData,
    isLoading,
    refetch
  } = useQuery('account', getAccount)

  const { dataResults, queryStore, isQueryLoading, page, setPage, shouldRefetch,
    setShouldRefetch } = useStore()

  const [calculatedCredits, setCalculatedCredits] = useState(0)
  const queryToDownload = queryStore?.query
  const dataToDownload = dataResults?.data // Business data to download
  const dataType = 'business' // Set dataType to business for download
  const TOTAL_NUMBER_RECORDS = dataResults?.data?.num_found
  const RECORDS_PER_PAGE = 50
  const isPreviousDisabled = page <= 1
  const totalNumberOfPages = Math.ceil(TOTAL_NUMBER_RECORDS / RECORDS_PER_PAGE)
  const isNextDisabled = page >= totalNumberOfPages
  const [startIndex, setStartIndex] = useState(1)
  const [endIndex, setEndIndex] = useState(RECORDS_PER_PAGE)

  const [isDownloadModalVisible, setIsDownloadModalVisible] = useState(false)

  useEffect(() => {
    if (!AccountData?.data?.plans) return;
    const plan = AccountData.data.plans.find(plan => plan.id?.includes('business'));
    if (plan) {
      const credits = plan?.credits_allotted - AccountData?.data?.business_credits_used;
      setCalculatedCredits(credits);
    }
  }, [AccountData]);

  useEffect(() => {
    if (shouldRefetch) {
      // call refetch
      refetch()
      // reset the flag to false
      setShouldRefetch(false)
    }
  }, [shouldRefetch, refetch, setShouldRefetch])

  const goToNextPage = () => {
    if (page < totalNumberOfPages) {
      setPage(page + 1)
    }
  }

  const goToPreviousPage = () => {
    if (page > 1) {
      setPage(page - 1)
    }
  }

  const toggleDownloadModal = () => {
    if (queryToDownload && !isQueryLoading) {
      setIsDownloadModalVisible(!isDownloadModalVisible)
    }
  }

  useEffect(() => {
    const newStartIndex = (page - 1) * RECORDS_PER_PAGE + 1
    const newEndIndex = Math.min(
      newStartIndex + RECORDS_PER_PAGE - 1,
      TOTAL_NUMBER_RECORDS
    )

    setStartIndex(newStartIndex)
    setEndIndex(newEndIndex)
  }, [page, RECORDS_PER_PAGE, TOTAL_NUMBER_RECORDS])

  const downloadStyle =
    isQueryLoading || !queryToDownload
      ? { cursor: 'not-allowed', opacity: 0.5 }
      : { cursor: 'pointer' }

  return (
    <div>
      <h1 className={styles.searchResultBusinessTitle}>Search results</h1>
      <div className={styles.searchResultBusinessFlexGap}>
        <div style={{ display: 'flex', gap:"20px" }}>
          <div>
            <span className={styles.searchResultBusinessTotalMatches}>
              Total available matches:
            </span>
            <span className={styles.searchResultBusinessTotalMatchesValue}>
              {dataResults?.data?.num_found
                ? dataResults?.data?.num_found.toLocaleString('en-US')
                : 'N/A'}
            </span>
          </div>

          <div>
            <span className={styles.searchResultBusinessRecordCredits}>
              Available record credits:
            </span>
            <span className={styles.searchResultBusinessRecordCreditsValue}>
              {isLoading
                ? 'Loading...'
                : AccountData?.data?.role === 'admin'
                ? 'Admin'
                : calculatedCredits
                ? calculatedCredits
                : 'N/A'}
            </span>
          </div>

          <div>
            <span
              className={styles.searchResultBusinessDownloadLabel}
              style={downloadStyle}
              onClick={toggleDownloadModal} // Trigger modal when clicked
            >
              Download
            </span>

            <img
              src={downloadPurple}
              alt='upload'
              style={downloadStyle}
              className={styles.searchResultBusinessDownloadIcon}
              onClick={toggleDownloadModal} // Trigger modal when clicked
            />
          </div>
        </div>
        <div style={{ display: 'flex', alignSelf:"end"}}>
          {dataResults?.data ? (
            <div className={styles.searchResultBusinessPaginationContainer}>
              <span className={styles.searchResultBusinessShowingRecords}>
                Showing records:
              </span>
              <span className={styles.searchResultBusinessShowingRecordsValue}>
                {startIndex} - {endIndex}
              </span>
              <img
                onClick={
                  !(isPreviousDisabled || isQueryLoading)
                    ? goToPreviousPage
                    : undefined
                }
                src={arrowLeft}
                alt='Previous'
                className={styles.searchResultBusinessArrow}
                style={{
                  opacity: isPreviousDisabled || isQueryLoading ? 0.5 : 1,
                  cursor: isNextDisabled || isQueryLoading || page === 1 ? "not-allowed" : "pointer"
                }}
              />
              <img
                onClick={
                  !(isNextDisabled || isQueryLoading) ? goToNextPage : undefined
                }
                src={arrowRight}
                alt='Next Page'
                className={styles.searchResultBusinessArrow}
                style={{
                  opacity: isNextDisabled || isQueryLoading ? 0.5 : 1,
                  cursor: isNextDisabled || isQueryLoading ? "not-allowed" : "pointer"
                }}
              />
            </div>
          ) : null}
        </div>
      </div>

      {dataResults?.data ? <Results /> : <ExampleSearches />}
      
      {/* Render DownloadModal for business data if the modal is visible */}
      {isDownloadModalVisible && (
        <DownloadModal
          onClose={toggleDownloadModal}
          totalRecords={TOTAL_NUMBER_RECORDS}
          dataToDownload={dataToDownload}
          queryToDownload={queryToDownload}
          dataType={dataType} // Pass the dataType as 'business'
        />
      )}
    </div>
  )
}

export default SearchResults
